export default __webpack_public_path__ + "static/header-7d48fede15f06e89c67d72b210ccd7bd8ea2c1c4372a54db12460a74e99de025.png";